import { render, staticRenderFns } from "./CRMMigrationResults.vue?vue&type=template&id=2dd58112&scoped=true&"
import script from "./CRMMigrationResults.vue?vue&type=script&setup=true&lang=js&"
export * from "./CRMMigrationResults.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CRMMigrationResults.vue?vue&type=style&index=0&id=2dd58112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd58112",
  null
  
)

export default component.exports